import TimeSheetComponent from 'components/TimeSheet';
import PermissionGuard from 'components/Global/PermissionGuard';

export const TimeSheets = () => {
	return (
		<PermissionGuard permission="Allow_Time_Sheets">
			<TimeSheetComponent />
		</PermissionGuard>
	);
};
